<template>
    <div class="modal history-modal fade" tabindex="-1" role="dialog" v-bind:style="modalStyle">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">
                        {{ userName ? userName + ' ' : '' }}
                        {{ '請假紀錄 ' + windowTitle }}
                    </h4>
                </div>
                <div class="modal-body" :style="contentStyle">

                    <div class="page">
                        <ul class="list-group dayoffHistory-list">
                            <li v-for="item in dayoff_history_list" :key="item.id">
                                <a class="list-group-item dayoffHistory-item" href="#" v-on:click.prevent="handleDayoffHistoryClick(item.start_date + ' ~ ' + item.end_date, item.start_date, item.end_date)">
                                    <span class="startdate">{{ item.start_date }}</span>
                                    <span class="split"> ~ </span>
                                    <span class="enddate">{{ item.end_date }}</span>
                                    <span class="glyphicon glyphicon-chevron-right pull-right"></span>
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="page">
                        <button class="button button-primary" @click="handleCloseDetailClick" >
                            <span class="glyphicon glyphicon-chevron-left">Back</span>
                        </button>
                        <history-detail :user-uuid="userUuid" :start-at="detail.start_date" :end-at="detail.end_date"></history-detail>
                    </div>

                </div>
                <!--<div class="modal-footer"></div>-->
            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
</template>

<script>
  import axios from 'axios';
  export default {
    components: {
      'history-detail': require('./history-detail.vue').default
    },

    props: [
      'user-name',
      'user-uuid',
      'modal-open',
    ],

    data() {
      return {
        detailViewing: false,
        windowTitle: '',
        dayoff_history_list: [],
        detail: {
          start_date: '',
          end_date: '',
        }
      }
    },

    methods: {
      handleDayoffHistoryClick: function(e, start_at, end_at) {
        this.detailViewing = true;
        this.detail.start_date = start_at;
        this.detail.end_date = end_at;
        this.windowTitle = e;
      },
      handleCloseDetailClick: function(e) {
        this.detailViewing = false;
        this.windowTitle = '';
      },
      updateData: function () {
        if (this.userUuid) {
          axios.get('/api/dayoff/user/' + this.userUuid + '/dayoff-history-list')
            .then((response) => {
              this.dayoff_history_list = response.data
            })
        }
      },
    },

    filters: {
      hourToSecond: {
        read: function (value) {
          return value / 3600;
        },
        write: function (value) {
          return value * 3600;
        }
      },
    },

    watch: {
      userUuid: function () {
        this.updateData();
      },
    },

    computed: {
      modalStyle: function () {
        var style = {
          'overflow-y': 'scroll'
        };

        if (this.modalOpen) {
          style.display = 'block';
        } else {
          style.display = 'none';
        }

        return style;
      },
      contentStyle: function () {
        var style = {}
        if (this.detailViewing) {
          style.transform = 'translateX(-50%)';
        }
        else {
          style.transform = 'translateX(0%)';
        }
        return style;
      }
    },

    mounted() {
      this.$watch('modalOpen', function (value) {
        var $modal = $(this.$el);
        if (value) {
          $modal.modal('show');
        } else {
          $modal.modal('hide');
        }
      });

      $('.history-modal').on('hidden.bs.modal', (function () {
        this.detailViewing = false;
      }).bind(this));

      this.updateData();

      this.$nextTick(function () {
        var value = this.modalOpen;
        var $modal = $(this.$el);
        if (value) {
          $modal.modal();
        } else {
          $modal.modal('hide');
        }
      })
    },
  }
</script>


<style lang="scss" scoped>

    .dayoffHistory-list{
        >li {
            &:first-child {
                >.dayoffHistory-item {
                    border-radius: 5px 5px 0px 0px;
                }
            }

            &:last-child {
                >.dayoffHistory-item {
                    border-radius: 0px 0px 5px 5px;
                }
            }
        }
    }

    .dayoffHistory-item{

        cursor: pointer;
        transition: 0.1s;
        margin-top: -1px;

        &:hover {
            background-color: #EEE;
        }
    }

    .modal-content {
        overflow-x: hidden;
        height: calc(100vh - 60px);
    }

    .modal-body {
        width: 200%;
        height: calc(100% - 56px);
        padding: 0px;
        display: flex;
        transition: .3s;
    }

    .page {
        width: 50%;
        height: 100%;
        overflow-y: scroll;
        padding: 15px;
        height: 100%;
    }

    .page2 {
        background-color: aqua;
        height: 500px;
    }

</style>
